export class RefreshTokenException extends Error {

}